<script>
    import _ from '@/common/helpers';
    import {vIcon} from '@/components/form';

    export default {
        name: 'v-separated',
        components: {},
        props: {
            list: {
                type: Array,
                required: true,
            },
            separator: {
                type: Object,
                default: () => ({props: {icon: 'caret-right'}}),
            },
            wrapper: {
                type: String,
                default: 'span',
            },
            type: {
                type: String,
                default: 'icon',
                validator: value => ['icon'].includes(value),
            },
        },
        methods: {
            getSeparatorComponent() {
                switch (this.type) {
                    case 'icon':
                    default:
                        return vIcon;
                }
            },
        },
        render(createElement) {
            return createElement(this.wrapper, _.separateArray(
                this.list,
                createElement(this.getSeparatorComponent(), {
                    ...this.separator,
                }),
            ));
        },
    };
</script>
